export const globalStyles = {
    global: {
        boxOuterContainer: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
        },
        boxInnerContainer: {
            minWidth: ["calc(100% - 2rem)", "15rem"],
            maxWidth: ["calc(100% - 2rem)", "auto"],
            height: ["calc(100% - 2rem)", "auto"],
            p: 2,
        },
        boxInnerContainerStackBox: {
            fontSize: "7rem",
            color: "primary.900",
            width: "600px"
        },
    },
    globalLoading: {
        linearProgress: {
            width: "100%",
        },
    },
    languageSwitcher: {
        boxContainer: {
            px: 2,
            py: 1,
        },
        switchButton: {
            p: 0,
        },
    },
}
